import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import styleUtils from '../../../../styles/style.utils';
import themedColor from '../../../../styles/theme/themed-color';
import themedFontSize from '../../../../styles/theme/themed-font-size';
import mediaBreakpoints from '../../../../styles/media-breakpoints';

const InputStyles = css`
  height: ${styleUtils.size('INPUT_HEIGHT')};
  background: ${themedColor('INPUT_BG')};
  border: 1px solid ${themedColor('INPUT_BORDER')};
  border-radius: 21px;
  padding: 0 ${styleUtils.px(16)};
  min-width: ${styleUtils.size('MIN_INPUT_WIDTH')};
  width: 100%;
  color: ${themedColor('TEXT_BLUE')};
  font-size: ${themedFontSize('FORM')};
  font-weight: 400;

  &:not([value='']) {
    border: 1px solid ${themedColor('INPUT_ENTERED_BORDER')};
    background: ${themedColor('INPUT_ENTERED_BG')};
  }

  &:focus {
    outline: 0;
    border-color: ${themedColor('INPUT_FOCUS_BORDER')};
  }

  &:hover {
    outline: 0;
    border-color: ${themedColor('INPUT_FOCUS_BORDER')};
  }

  &:read-only {
    border: 1px solid ${themedColor('DARK_GREY')};
    background: ${themedColor('GRAY')};
    color: ${themedColor('DARK_GREY')};
    cursor: not-allowed;
  }
`;

interface ContainerProps {
  customWidth?: string;
}
const Container = styled.div<ContainerProps>`
  margin-bottom: ${styleUtils.px(18)};
  width: 100%;

  ${({ customWidth }: ContainerProps): FlattenSimpleInterpolation =>
    mediaBreakpoints.greaterThan('M')`
      // IE 11 hack
     flex-basis:  calc(${customWidth || `50%`} - 32px);
     
      @supports (display: grid) {
       flex-basis:  ${customWidth || `50%`};
      }
  `};

  input[type='text'],
  input[type='number'] {
    ${InputStyles}
  }
`;

const StyledInput = styled.input`
  ${InputStyles}
`;

const FormInputComponents = {
  Container,
  StyledInput
};

export default FormInputComponents;
